export default __webpack_public_path__ + "static/media/m22.4d1ad2b2.png";